export default __webpack_public_path__ + "static/puccini-91285ba8f5a4e974a09ae6cfc14957e9.jpg";